import {
    MORE_620_MEDIA_QUERY,
    MORE_768_MEDIA_QUERY,
    MORE_984_MEDIA_QUERY,
    MORE_1024_MEDIA_QUERY
} from '../../../consts/adaptive';


export const styles = {
    container: {
        padding: [20, 0, 10],
        fontSize: 12,
        lineHeight: '18px',
    },
    item: {
        boxSizing: 'border-box',

        '&:last-child': {
            marginTop: 16
        }
    },
    title: {
        color: '#9b9b9b'
    },
    text: {
        marginTop: 2,
        marginBottom: 0
    },
    [MORE_620_MEDIA_QUERY]: {
        container: {
            display: 'flex'
        },
        item: {
            width: '50%',

            '&:last-child': {
                marginTop: 0,
                paddingLeft: 8
            }
        }
    },
    [MORE_768_MEDIA_QUERY]: {
        container: {
            fontSize: 14,
            lineHeight: '20px'
        },
        text: {
            marginTop: 4
        }
    },
    [MORE_984_MEDIA_QUERY]: {
        item: {

            '&:first-child': {
                paddingLeft: 0
            },
            '&:last-child': {
                paddingLeft: 12
            }
        },
        text: {
            maxWidth: 350
        }
    },
    [MORE_1024_MEDIA_QUERY]: {
        container: {
            padding: [20, 0, 20, 0]
        }
    }
};

export type ComponentJSSClasses = typeof styles;
